// Form 2290 tax period for the dashboard's Tax Period card. Not hardcoded to a year:
// it comes from GET /lookups/tax-years (the current period's code, e.g. "2026"), and
// the period always runs July 1 of that year through June 30 of the next (Form 2290:
// "For the period July 1, 2026, through June 30, 2027").

export function formatDate(date) {
  return date ? date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—";
}

// taxYears: GET /lookups/tax-years rows, current period first.
export function getTaxPeriod(taxYears) {
  const year = Number(taxYears?.[0]?.code);
  if (!year) return null;
  return { taxYear: String(year), start: new Date(year, 6, 1), end: new Date(year + 1, 5, 30) };
}
